// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { outdent16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-outdent': IconOutdent;
    }
}

/**
 * The icon component for the 'outdent' icon
 */
export class IconOutdent extends Icon {
    public constructor() {
        super(outdent16X16);
    }
}

registerIcon('icon-outdent', IconOutdent);
export const iconOutdentTag = 'nimble-icon-outdent';
